module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1154.1f4f827f.png";